// extracted by css-extract-rspack-plugin
export default {"deadlineCalendar":"deadlineCalendar-Muw0hC","deadlineContainer":"deadlineContainer-Wr4l1q"};